import React from 'react';
import './App.css';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://production';

interface ServerData {
  description: string;
  rewards: string[];
  showForm: boolean;
  tier: string;
};

interface AppState {
  serverData: ServerData | null;
};

interface ReedemFormProps {
  submitCallback: (name: string, password: string) => void;
};
const RedeemForm: React.FC<ReedemFormProps> = (props) => {
  let nameRef = React.createRef<HTMLInputElement>();
  let passwordRef = React.createRef<HTMLInputElement>();
  let formRef = React.createRef<HTMLFormElement>();

  return (
    <div className="redeem_form">

      <h3>Redeem</h3>
    
      <form ref={formRef}>
        <div className="form-group">
        <label>Username</label>         
            <input className="form-control" ref={nameRef} type="text" 
              required
              pattern="[A-Za-z0-9]+"/>
        </div>

        <div className="form-group">
          <label>Password</label>         
          <input className="form-control" ref={passwordRef} type="password"
              required/>
        </div>  

        <button 
          type="button" className="btn btn-primary"
          onClick={e => {
              if (formRef.current?.reportValidity()) {
                props.submitCallback(
                  nameRef.current!.value,
                  passwordRef.current!.value);
              }
            }}>Redeem</button>          
      </form>
        

    </div>);
}


class App extends React.Component<any, AppState> {


  constructor(props: any) {
    super(props);
    this.state = { serverData: null };

  }

  async componentDidMount() {
    let resp = await fetch(API_ENDPOINT + "/kickstarter/info" + window.location.pathname);
    console.log(resp);
    let text = await resp.clone().text();
    resp.json()
      .then(data => {
        console.log(data);
        this.setState({serverData: data});
      })
      .catch(error => {
        this.setState({serverData: {
          description: text,
          rewards: [],
          showForm: false,
          tier: "",
        }});
      });
  }

  async redeem(name: string, password: string) {
    let resp = await fetch(API_ENDPOINT + "/kickstarter/redeem" + window.location.pathname, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: name,
        password: password
      })
    });
    console.log(resp);
    let text = await resp.clone().text();
    resp.json()
      .then(data => {
        console.log(data);
        this.setState({serverData: data});
      })
      .catch(error => {
        this.setState({serverData: {
          description: text,
          rewards: [],
          showForm: false,
          tier: "",
        }});
      });
  }
    
  render() {
    let form = <div>Loading...</div>;
    
    if (this.state.serverData) {
      let d = this.state.serverData;

      let redeemForm = d.showForm
        ? <RedeemForm submitCallback={(n,p) => this.redeem(n,p)}/>
        : null;

      let tier = d.tier !== ""
        ? <h3 className="tier">{d.tier}</h3>
        : null;

      form = (
        <div>
        <div className="main">
        {tier}
        <p>{d.description}</p>
        <ul className="rewards">
          { d.rewards.map(r => <li>{r} </li>) }
        </ul>
        </div>
        {redeemForm}
        </div>);
    }

    return (
      <div className="container">
         
          { form }

      </div>
    );  
  }
}


export default App;
